<template>
  <div class="option" @click="toggle">
    <div
        class="toggle"
        :class="[{'active':data.enabled}, data.color]"
    ></div>
    <div v-html="label" class="text"></div>
  </div>
</template>

<script>
export default {
  name: "Option",
  props: {
    data: Object
  },
  computed: {
    label() {
      return this.data.enabled ? this.data.title.enabled : this.data.title.disabled;
    }
  },
  methods: {
    toggle() {
      this.$root.$emit('optionToggled', this.data.key, this.data.package)
    },
  },
}
</script>
